module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAloAAAAgCAMAAAD9oyZWAAAAHlBMVEVHcEz/dl/+cV7+dl/+eV39bF39a2H9amD9bGD+bWBZQYknAAAACnRSTlMAI1g8EHb+4MmnyUl91wAAAOJJREFUeNrt2UFuxCAMQFEbGwP3v3AxYaouomSa5cx/ipR99GUCCAAAAAAAAAAA+Eo6BNd8uODftAVtXfMenbaelBW0dVdW0NaTsroxt27KatZo60FZzpp4V5aK0pa4eFLXxdS2YuWllrrtD8bcui4r3y163UotL1ZsU9PF1Rf5OJnVZGmHtIw6lr60FEkllYgqODEiTJJFaqmncajjb202afrMtpLO52C/ip1PLXaJ70wtzal1KPM52OnUUp/k25dP/rX412KHyA6Rcy3OtcBpPKfx3CFyhwgAAAAAAAAAeNcPYFwHzzM+FxEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/how-to-get-bg.png
// module id = UyMv
// module chunks = 216